import React from 'react';
import { autobind } from 'core-decorators';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Content from 'src/componentes/pages/content';

import View from './View';
import Tabs from 'src/componentes/tabs/tabs';
import Tab from 'src/componentes/tabs/tab';
import RiscoCategorizadoView from './RiscoCategorizado/RiscoCategorizadoView';
import { getConfiguration } from 'src/services/commonRequests';

@autobind
class Risco extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      idFiltroSalvo: 0,
      ehFavorito: false,
      tipoFiltro: null,
      configuracao: null,
    };
  }

  componentDidMount() {
    getConfiguration('ItemConfiguracaoRisco')((configuracao) => {
      this.setState({ ...this.state, configuracao });
    })();
  }

  getFiltroFavorito = (id, ehFavorito, tipoFiltro) => {
    this.setState({
      idFiltroSalvo: id,
      ehFavorito: ehFavorito,
      tipoFiltro: tipoFiltro,
    });
  };

  render() {
    const { resources, showModal, intl, ...rest } = this.props;
    return this.props.hideHead ? (
      <View showCustomFields={true} {...rest} showModal={showModal} configuracao={this.state.configuracao}/>
    ) : (
      <Content
        data-testid="gerenciar-risco-page"
        titulo={intl.formatMessage(
          {
            id: 'riscosMapeados',
          },
          { riscos: resources.riscos }
        )}
        iconSettings={true}
        urlSettings="/configuracoes/risco"
        endPointPermissionSettings="/itemConfiguracaoRisco/PossuiPermissaoConfiguracao"
        iconFavorite={true}
        filtroFavorito={{
          id: this.state.idFiltroSalvo,
          ehFavorito: this.state.ehFavorito,
          tipoFiltro: this.state.tipoFiltro,
        }}
      >
        <Tabs>
          <Tab label={resources.riscos} key={0}>
            <View
              configuracao={this.state.configuracao}
              showCustomFields={true}
              {...rest}
              showModal={showModal}
              getFiltroFavorito={this.getFiltroFavorito}
            />
          </Tab>
          {this.state.configuracao?.habilitarDicionarioRiscos && (
            <Tab
              label={intl.formatMessage(
                { id: 'labelDicionarioRiscos' },
                { riscos: resources.riscos }
              )}
              key={1}
            >
              <RiscoCategorizadoView />
            </Tab>
          )}
        </Tabs>
      </Content>
    );
  }
}
function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(connect(mapStateToProps)(Risco));
